import projectCategories from '../content/projects/categories.json'

export default function useProjectCategories() {
    return projectCategories
}
